// extracted by mini-css-extract-plugin
export default {"auth_input_label":"styled_auth_input_label__JOvfv","auth_input":"styled_auth_input__It5Jf","auth_input_error_text":"styled_auth_input_error_text__XB8GA"};